/** The serving status of a product in an order. */
export enum OrderItemStatus { 
	/** The product was not started yet. */
	Open = "Open", 
	/** The product is being served right now. */
	Serving = "Serving", 
	/** The product could be served successfully. */
	Successful = "Successful", 
	/** The product could not be served. */
	Failed = "Failed"
}
